/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable import/max-dependencies */
/* eslint-disable max-lines */
import React, {
  useEffect, useCallback,
} from 'react'
import {
  useResponsiveWrapperContext,
} from '@usap/uicomponents'
import { useFeatureFlagCookieContext } from '@usap/core'

import paymentConfig from '../../../../../config/payment-config'

import SummaryWmo from './SummaryWmo'

const PAYPAL_SDK = paymentConfig.PAYPAL_SDK_URL

const Summary = props => {
  const { data, showLoader } = props
  const { summary } = data
  const { total, taxTotal } = summary
  const totalAfterTax = total - taxTotal
  const { multiShippingDiscountFlag, cpn_off: isCouponOff } = useFeatureFlagCookieContext()
  const { isDesktop } = useResponsiveWrapperContext()
  const injectScript = useCallback(
    () => {
      const script = document.createElement('script')
      script.setAttribute('type', 'text/javascript')
      script.setAttribute('src', PAYPAL_SDK)
      script.setAttribute('async', true)
      document.head.appendChild(script)
    },
    [],
  )

  useEffect(() => {
    if (__BROWSER__ && !window.paypal) {
      injectScript(PAYPAL_SDK)
    }
  }, [injectScript])

  return (
    <SummaryWmo
      data={data}
      multiShippingDiscountFlag={multiShippingDiscountFlag}
      isCouponOff={isCouponOff}
      totalAfterTax={totalAfterTax}
      isDesktop={isDesktop}
      showLoader={showLoader}
    />
  )
}

export default Summary
